// api/reservations.js
// 予約に関するAPIを実装する

import Api from './api_base'

export default {
  // GET /reservations 登録されている全予約情報を取得する
  get: (id) => {
    return Api.get('/reservations', {
      params: {
        school_id: id
      }
    })
    .catch((err) => {
      console.log(err)
    })
  },
  // GET /reservations/{id} 指定した予約idの予約情報を取得する
  getById: (id) => {
    return Api.get('/reservations/' + id)
    .catch((err) => {
      console.log(err)
    })
  },
  // GET /reservations?date={date} 指定した日付の予約情報を取得する
  getByDate: (data) => {
    console.log('getByDate')
    return Api.get('/reservations', {
      params: {
        date: data.date,
        school_id: data.school_id
      }
    })
    .catch((err) => {
      console.log(err)
    })
  },
  // GET /reservations?user_id={user_id} 指定したユーザidの予約情報を取得する
  getByUserId: (uid) => {
    return Api.get('/reservations', {
      params: {
        user_id: uid
      }
    })
    .catch((err) => {
      console.log(err)
    })
  },
  // GET /reservations?recurrence_id={recurrence_id} 指定した繰り返しidに紐付いた予約情報を取得する
  getByRecurrenceId: (rid) => {
    return Api.get('/reservations', {
      params: {
        recurrence_id: rid
      }
    })
    .catch((err) => {
      console.log(err)
    })
  },
  // GET /reservations?all=1&date={date}
  getAllByDate: (data) => {
    console.log('getAllByDate')
    return Api.get('/reservations', {
      params: {
        all: 1,
        date: data.date,
        school_id: data.school_id
      }
    })
    .catch((err) => {
      console.log(err)
    })
  },
  // POST /reservations 予約情報を登録する
  post: (reservation) => {
    return Api.post('/reservations', reservation)
  },
  // PUT /reservations/{id} 指定したidの予約情報を変更す
  put: (id, reservation) => {
    return Api.put('/reservations/' + id, reservation)
  },
  // DELETE /reservations/{id} 指定したidの予約情報を消去する
  delete: (id) => {
    return Api.delete('/reservations/' + id)
    .catch((err) => {
      console.log(err)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/reservations.js